//GLOBAL - components from npm
import React from 'react';

//STYLES
import './h3.scss'

//COMPONENTS


//SERVICES - api, conectors...


//GLOBAL STATE - redux, env...


//ASSETS - icons, images...


export default function H3({
  className,
  children,
  weight,
  color
}) {

  //GENERAL
  const mainClassName = 'typography-h3'

  //STATES


  //REDUX - Selectors


  //FUNCTIONS


  //USE EFFECTS


  return (
    <h2 className={`${mainClassName} ${className ? className : ''} ${weight ? `${mainClassName}--${weight}` : ''} ${color ? `${mainClassName}--color-${color}` : ''}`}>
      {children}
    </h2>
  )
}
